import { Modal } from 'antd'
import Button from '@UI/New/Button'
import s from './index.module.css'

// The student form can also be opened under the platform training overlay.
const CONFLICT_MODAL_Z_INDEX = 2147483100

const Lesson = ({ lesson }) => (
  <div className={s.lesson}>
    <div>{lesson?.date} {lesson?.weekday}</div>
    <strong>{lesson?.start_time}–{lesson?.end_time}</strong>
    <div>{lesson?.course_name || 'Без названия'}</div>
    <div>{lesson?.lesson_type}</div>
    {lesson?.source_row != null && <div>Строка Excel: {lesson.source_row}</div>}
  </div>
)

const TimetableConflicts = ({ data, checkOnly, isEditing = false, onConfirm, onCancel, confirmText, description, proposedTitle }) => {
  const summary = data.summary ?? {}
  const importInfo = data.import
  const warnings = importInfo?.warnings

  return (
    <Modal
      open
      title="Найдены пересечения в расписании"
      onCancel={onCancel}
      maskClosable={false}
      width={900}
      zIndex={CONFLICT_MODAL_Z_INDEX}
      footer={
        <div className={s.actions}>
          <Button color="gray" onClick={onCancel}>Отмена</Button>
          <Button onClick={onConfirm}>
            {confirmText || (checkOnly ? 'Продолжить с пересечениями' : isEditing ? 'Сохранить всё равно' : 'Создать всё равно')}
          </Button>
        </div>
      }
    >
      <div className={s.content}>
        <p>{description || `${isEditing ? 'Изменения ещё не сохранены.' : 'Занятия ещё не созданы.'} Участники заняты в указанное время.`}</p>
        <p>
          Проверенный период: {data.checked_from} — {data.checked_to}.
          {' '}Регулярные занятия проверяются в пределах 28 календарных дней.
          {' '}Дата и время указаны по расписанию.
        </p>
        <p>
          Учеников: {summary.students ?? '—'} · Педагогов: {summary.teachers ?? '—'}
          {' '}· Занятий с пересечениями: {summary.occurrences ?? '—'}
          {' '}· Пересечений: {summary.conflicts ?? data.conflicts.length}
        </p>
        {importInfo && (
          <div>
            <p>
              Строк в файле: {importInfo.rows_total ?? '—'} · Пропущено: {importInfo.rows_skipped ?? '—'}
              {' '}· Занятий к созданию: {importInfo.lessons_to_create ?? '—'}
            </p>
            {Array.isArray(warnings) && warnings.length > 0 && (
              <ul>{warnings.map((warning, index) => (
                <li key={index}>{typeof warning === 'string' ? warning : JSON.stringify(warning)}</li>
              ))}</ul>
            )}
          </div>
        )}
        <div className={s.tableWrapper}>
          <table className={s.table}>
            <thead>
              <tr><th>Участник</th><th>{proposedTitle || (isEditing ? 'Изменяемое занятие' : 'Создаваемое занятие')}</th><th>Пересекающееся занятие</th></tr>
            </thead>
            <tbody>
              {data.conflicts.map((conflict, index) => (
                <tr key={index}>
                  <td>
                    <div>{conflict.resource?.type === 'student' ? 'Ученик' : conflict.resource?.type === 'teacher' ? 'Педагог' : 'Участник'}</div>
                    <strong>{conflict.resource?.name || 'Без имени'}</strong>
                  </td>
                  <td><Lesson lesson={conflict.proposed} /></td>
                  <td><Lesson lesson={conflict.existing} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  )
}

export default TimetableConflicts
